module.exports = __webpack_public_path__ + "img/bespoke70_03.476d6a5d.jpg";